import { render, staticRenderFns } from "./naturalGas.vue?vue&type=template&id=68fb86c2&scoped=true"
import script from "./naturalGas.vue?vue&type=script&lang=js"
export * from "./naturalGas.vue?vue&type=script&lang=js"
import style0 from "./naturalGas.vue?vue&type=style&index=0&id=68fb86c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb86c2",
  null
  
)

export default component.exports